<template class="notice-log-container">
  <div class="view-point-app-container" style="position: relative; height: 100%; padding: 10px">
    <!-- <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth">
          <el-form-item
            :label="funcName + '名稱'"
            prop="viewPointName"
            :rules="[
              { required: true, message: '請輸入景點名稱', trigger: 'blur' },
            ]"
          >
            <el-input v-model="form.viewPointName"></el-input>
          </el-form-item>

          <el-form-item :label="funcName + '座標'">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="緯度(lat)"
                  prop="lat"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標緯度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標緯度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="form.lat"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="經度(lng)"
                  prop="lng"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標經度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標經度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="form.lng"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">確 定</el-button>
      </span>
    </el-dialog> -->

    <div style="padding: 20px; padding-bottom: 0">
      <el-form style="display: flex; align-items: flex-end; gap: 0 8px" label-position="left">
        <!-- <el-form-item label="代碼查詢">
          <el-input v-model="listQuery.qry" placeholder="輸入景點名稱" />
        </el-form-item> -->
        <el-form-item :label="'通知類型'">
          <el-select v-model="listQuery.fcmType" filterable clearable placeholder="請選擇通知類型">
            <el-option
              v-for="item in fcmTypeOption"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
        <el-form-item>
          <NotificationSetting type="ita" />
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="資料ID" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="推播時間" width="160">
          <template slot-scope="scope">
            <el-tag effect="dark" type="success">{{ scope.row.recordDate }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="left" label="旅遊團" width="250">
          <template slot-scope="scope">
            <span v-if="scope.row.travelID"
              >(ID:{{ scope.row.travelID }}){{ scope.row.travelName }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="使用者名稱" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="Tokens" width="130">
          <template slot-scope="scope">
            <el-popover
              v-for="(item, index) in scope.row.tokenList"
              :key="index"
              placement="top-start"
              :title="`Token ${index + 1}`"
              width="200"
              trigger="hover"
              :content="item"
            >
              <el-button slot="reference">{{ `Token ${index + 1}` }}</el-button>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column align="left" label="傳送類型" width="110">
          <template slot-scope="scope">
            <el-tag
              effect="dark"
              :type="fcmTypeTransfer(scope.row.fcmType) % 2 == 0 ? 'success' : ''"
              >{{ scope.row.fcmTypeDesc }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="傳送內容" width="450">
          <template slot-scope="scope">
            <el-tag effect="dark" type="info">{{ scope.row.content }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="成功筆數" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.successCount == 0"></span>
            <el-tag v-else effect="dark" type="success">{{ scope.row.successCount }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="失敗筆數" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.failureCount == 0"></span>
            <el-tag v-else effect="dark" type="danger">{{ scope.row.failureCount }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="left" label="MessageID" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.messageId }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import NotificationSetting from '@/views/ita/appManage/components/notificationSetting.vue'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import { getFcmNoticeHistory, getFcmTypeOption } from '@/api/system'

var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'NoticeLog',
  components: {
    Pagination,
    NotificationSetting,
  },
  data() {
    return {
      funcName: '推播通知紀錄',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        fcmType: null,
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
      fcmTypeOption: [],
    }
  },
  async created() {
    this.form = defaultForm
    await this.getFcmTypeOption()
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        fcmType: null,
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    fcmTypeTransfer(v) {
      const descMap = {
        onlySend: 1,
        message: 2,
        itineraryPlanning: 3,
        gatherAround: 4,
        tour: 5,
        vote: 6,
        carryItem: 7,
        alarm: 8,
      }
      return descMap[v]
    },
    async getFcmTypeOption() {
      let resp = await getFcmTypeOption()
      this.fcmTypeOption = resp.data
    },
    tokensToArray(t) {
      let ary = JSON.parse(t)
    },

    async getList() {
      this.listLoading = true
      let resp = await getFcmNoticeHistory(this.listQuery)
      console.log(resp)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.notice-log-container .el-popover .el-popper .el-popover--plain {
  width: 500px;
}
</style>
